
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/osrodki-narciarskie",
      function () {
        return require("private-next-pages/[region]/osrodki-narciarskie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/osrodki-narciarskie"])
      });
    }
  